// -----------------------------------------------------------------------------
export class StopWatch {
  // ---------------------------------------------------------------------------
  private _startTime = 0;
  private _stopTime = 0;
  private _initialized = false;

  // ---------------------------------------------------------------------------
  public get initialized(): boolean {
    return this._initialized;
  }

  // ---------------------------------------------------------------------------
  public start(): void {
    this._stopTime = 0;
    this._startTime = Date.now();

    this._initialized = true;
  }

  // ---------------------------------------------------------------------------
  public stop(): number {
    if (!this._initialized) {
      return 0;
    }

    this._stopTime = Date.now();
    return this._stopTime - this._startTime;
  }

  // ---------------------------------------------------------------------------
  public getTime(): number {
    if (!this._initialized) {
      return 0;
    }

    if (this._stopTime > 0) {
      return this._stopTime - this._startTime;
    }

    // Just means we are still running (i.e. stop wasn't called yet)
    return Date.now() - this._startTime;
  }
}
